import { render } from "./HlxTable.vue?vue&type=template&id=3222e120"
import script from "./HlxTable.vue?vue&type=script&lang=js"
export * from "./HlxTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__